import { HAS_OIDC_COOKIE_STATE_KEY } from '~/utils/shop/hasOidcSessionCookie';

export default defineNuxtPlugin({
  name: 'session-fetch-plugin',
  enforce: 'pre',
  async setup() {
    // Default true: if the SSR flag is missing, still fetch (safe).
    if (!useState(HAS_OIDC_COOKIE_STATE_KEY, () => true).value) {
      return;
    }

    await useOidcAuth().fetch();
  }
});
